"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC1155Schema = void 0;
const ethereum_types_1 = require("ethereum-types");
const types_1 = require("../../types");
exports.ERC1155Schema = {
    version: 1,
    deploymentBlock: 0,
    name: 'ERC1155',
    description: 'Items conforming to the ERC1155 spec, using transferFrom.',
    thumbnail: 'https://opensea.io/static/images/opensea-icon.png',
    website: 'https://github.com/ethereum/eips/issues/1155',
    fields: [
        { name: 'ID', type: 'uint256', description: 'Asset Token ID' },
        { name: 'Address', type: 'address', description: 'Asset Contract Address' },
        { name: 'Quantity', type: 'uint256', description: 'Quantity to transfer' },
    ],
    assetFromFields: (fields) => ({
        id: fields.ID,
        address: fields.Address,
        quantity: fields.Quantity,
    }),
    assetToFields: (asset) => ({
        ID: asset.id,
        Address: asset.address,
        Quantity: asset.quantity,
    }),
    formatter: (asset) => __awaiter(void 0, void 0, void 0, function* () {
        return {
            title: 'ERC1155 Asset: Token ID ' + asset.id + ' at ' + asset.address,
            description: 'Trading ' + asset.quantity.toString(),
            url: '',
            thumbnail: '',
            properties: [],
        };
    }),
    functions: {
        transfer: (asset) => ({
            type: ethereum_types_1.AbiType.Function,
            name: 'safeTransferFrom',
            payable: false,
            constant: false,
            stateMutability: types_1.StateMutability.Nonpayable,
            target: asset.address,
            inputs: [
                { kind: types_1.FunctionInputKind.Owner, name: '_from', type: 'address' },
                { kind: types_1.FunctionInputKind.Replaceable, name: '_to', type: 'address' },
                {
                    kind: types_1.FunctionInputKind.Asset,
                    name: '_id',
                    type: 'uint256',
                    value: asset.id,
                },
                {
                    kind: types_1.FunctionInputKind.Count,
                    name: '_value',
                    type: 'uint256',
                    value: asset.quantity,
                },
                {
                    kind: types_1.FunctionInputKind.Data,
                    name: '_data',
                    type: 'bytes',
                    value: '',
                },
            ],
            outputs: [],
        }),
        checkAndTransfer: (asset, validatorAddress, merkle) => ({
            type: ethereum_types_1.AbiType.Function,
            name: 'matchERC1155UsingCriteria',
            payable: false,
            constant: false,
            stateMutability: types_1.StateMutability.Nonpayable,
            target: validatorAddress,
            inputs: [
                { kind: types_1.FunctionInputKind.Owner, name: 'from', type: 'address' },
                { kind: types_1.FunctionInputKind.Replaceable, name: 'to', type: 'address' },
                {
                    kind: types_1.FunctionInputKind.Asset,
                    name: 'token',
                    type: 'address',
                    value: asset.address,
                },
                {
                    kind: types_1.FunctionInputKind.Asset,
                    name: 'tokenId',
                    type: 'uint256',
                    value: asset.id,
                },
                {
                    kind: types_1.FunctionInputKind.Count,
                    name: 'amount',
                    type: 'uint256',
                    value: asset.quantity,
                },
                {
                    kind: types_1.FunctionInputKind.Data,
                    name: 'root',
                    type: 'bytes32',
                    value: merkle ? merkle.root : '',
                },
                {
                    kind: types_1.FunctionInputKind.Data,
                    name: 'proof',
                    type: 'bytes32[]',
                    value: merkle ? merkle.proof : '[]',
                },
            ],
            outputs: [],
        }),
        countOf: (asset) => ({
            type: ethereum_types_1.AbiType.Function,
            name: 'balanceOf',
            payable: false,
            constant: true,
            stateMutability: types_1.StateMutability.View,
            target: asset.address,
            inputs: [
                { kind: types_1.FunctionInputKind.Owner, name: '_owner', type: 'address' },
                {
                    kind: types_1.FunctionInputKind.Asset,
                    name: '_id',
                    type: 'uint256',
                    value: asset.id,
                },
            ],
            outputs: [
                { kind: types_1.FunctionOutputKind.Count, name: 'balance', type: 'uint' },
            ],
            assetFromOutputs: (outputs) => outputs.balance,
        }),
        assetsOfOwnerByIndex: [],
    },
    events: {
        transfer: [],
    },
    hash: (asset) => asset.address + '-' + asset.id,
};
